import http from '../../../common/Http';


/**
 * 获取订单列表
 * @param page
 * @param pageSize
 * @returns {Promise<any>}
 */
function getOrderList(page = 1,pageSize = 10,status = ''){
    let url = '/v1/order/list';
    return http("get",url,{
        page: page,
        pageSize: pageSize,
        status: status,
    });
}


/**
 * 获取订单信息
 * @param orderId
 * @returns {Promise<any>}
 */
function getOrderById(orderId){
    let url = '/v1/order/' + orderId;
    return http("get",url);
}


/**
 * 创建订单
 * @param params
 * @returns {Promise<any>}
 */
function createOrder(params) {
    let url = '/v1/order/create';
    return http("post",url,params);
}


/**
 * 创建汇款信息
 * @param params
 * @returns {Promise<any>}
 */
function orderByRemitter(params) {
    let url = '/v1/order/pay/remitter';
    return http("post",url,params);
}


/**
 * 创建订单初始话页面
 * @returns {*|Promise|Promise<any>}
 */
function pageCreateOrderInit() {
    let url = '/v1/order/create/init';
    return http("get",url);
}

export {
    getOrderList,
    getOrderById,
    createOrder,
    orderByRemitter,
    pageCreateOrderInit
}

